export const Constants = {
  // 1. Initial / Draft States
  saveAsDraft: 4410,

  // 2. Approval Workflow
  awaitingApproval: 4415,
  sentForRepairCode: 4420,
  rejectedByApprover: 4425,
  approvedByApprover: 4445,
  selfApproved: 4446,
  pendingConsentAuthorization: 4447,

  // 3. Bank Submission & Processing
  pendingWithBankSameCurrency: 4450,
  pendingWithBankCrossCurrency: 4455,
  inProcessWithBank: 4465,
  rejectedByBank: 4430,
  processedByBank: 4440,

  // 4. Future Dated & Scheduling
  futureDatedPayment: 4480,
  scheduled: 4481,
  futureDatedPaymentStarted: 4485,
  futureDatedPaymentCompleted: 4490,

  directBank: "DB",
  centralBank: "CB",
  otp: "OTP",
  gOtp: "GOTP",
  mOtp: "MOTP",
  yes: "YES",
  notApplicable: "NA",
  null: null,
  device: "DEVICE",
  no: "NO",
  admin: "admin",
  user: "user",
  approve: "A",
  sentForRepair: "SR",
  reject: "R",
  ascending: "Asc",
  descenting: "Dsc",
  pending: "P",
  fail: "F",
  success: "S",
  viewAccess: "View",
  approveAccess: "Approve",
  type: "type",
  subFeatureId: "subFeatureId",
  swiftBicCode: "swiftBicCode",
  paymentCountryCode: "paymentCountryCode",
  countryCode2: "countryCode2",
  countryCode: "countryCode",
  paymentTypeKey: "paymentTypeKey",
  ownAccoutPay: "OAPAY",
  bookTransferPay: "BTPAY",
  domesticPay: "DTPAY",
  docDomesticPay: "DOCPAY_DTPAY",
  pixDomesticPay: "PIX_DTPAY",
  swiftPay: "SWIFTPAY",
  loanPay: "LOANPAY",
  aaniPay: "AANI_DTPAY",
  soFrequency: "SO_FREQUENCY",
  soExecutionDays: "SO_EXECUTION_DAYS",
  chargeBearerType: "CHARGE_BEARER_TYPE",
  y: "Y",
  n: "N",
  d: "D",
  c: "C",
  statusSuccess: "SUCCESS",
  statusFail: "FAIL",
  shared: "Shared",
  dummyPassword: "12345678",
  errorMessages: {
    INSUFFICIENT_FUNDS:
      "Your account balance is too low to complete this payment.",
    INVALID_DETAILS:
      "The account information entered is incorrect. Please double-check and try again.",
    NETWORK_ERROR:
      "We’re having trouble connecting right now. Please check your internet and retry.",
    AUTH_FAILURE:
      "The security verification failed. Please re-enter your PIN/OTP and try again.",
    REGULATORY_BLOCK:
      "This transaction exceeds the permitted limits. Please adjust the amount or try later.",
    TECH_ERROR:
      "Something went wrong on our side. Please try again in a few minutes.",
    FRAUD_DETECTED:
      "For your safety, this payment has been blocked. Contact support if you believe this is an error.",
  },
};
